/**
 * Efeitos sonoros do destaque "Você foi reconhecido" (porta do RB_SFX do
 * handoff). Sons curtos sintetizados via WebAudio — sem assets externos.
 * O contexto de áudio só destrava após o primeiro gesto do usuário
 * (política de autoplay dos navegadores); chamadas antes disso são silenciosas.
 */

let audioContext: AudioContext | null = null;

function getContext(): AudioContext | null {
  try {
    if (!audioContext) {
      const Ctor = window.AudioContext || (window as any).webkitAudioContext;
      if (!Ctor) return null;
      audioContext = new Ctor();
    }
    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }
    return audioContext;
  } catch (e) {
    return null;
  }
}

function blip(
  ctx: AudioContext,
  frequency: number,
  startTime: number,
  duration: number,
  type: OscillatorType,
  volume: number,
  targetFrequency?: number,
) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startTime);
  if (targetFrequency) {
    oscillator.frequency.exponentialRampToValueAtTime(targetFrequency, startTime + duration);
  }
  gain.gain.setValueAtTime(0.0001, startTime);
  gain.gain.linearRampToValueAtTime(volume, startTime + 0.014);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(startTime);
  oscillator.stop(startTime + duration + 0.03);
}

export function playNivelSound(nivel: string) {
  const ctx = getContext();
  if (!ctx) return;

  const t = ctx.currentTime + 0.03;

  if (nivel === 'semeou') {
    [0, 0.06, 0.13, 0.19, 0.25].forEach(delay => {
      blip(ctx, 540 + Math.random() * 260, t + delay, 0.11, 'triangle', 0.045);
    });
  } else if (nivel === 'cresceu') {
    blip(ctx, 330, t, 0.3, 'sine', 0.06, 540);
    blip(ctx, 494, t + 0.16, 0.36, 'sine', 0.05, 680);
  } else if (nivel === 'floriu') {
    [523, 659, 784, 1047].forEach((frequency, i) => {
      blip(ctx, frequency, t + i * 0.09, 0.55, 'triangle', 0.05);
    });
  }
}

export function unlockAudioOnFirstGesture() {
  const unlock = () => {
    getContext();
    document.removeEventListener('pointerdown', unlock);
  };
  document.addEventListener('pointerdown', unlock, { once: true });
}
